import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const FAQ = () => {
  const { t } = useLanguage();
  

  const commonQuestions = [
    {
      questionKey: 'faq.q1',
      answerKey: 'faq.a1',
    },
    {
      questionKey: 'faq.q2',
      answerKey: 'faq.a2',
    },
    {
      questionKey: 'faq.q3',
      answerKey: 'faq.a3',
    },
    {
      questionKey: 'faq.q4',
      answerKey: 'faq.a4',
    },
    {
      questionKey: 'faq.q5',
      answerKey: 'faq.a5',
    },
    {
      questionKey: 'faq.q6',
      answerKey: 'faq.a6',
    },
  ];

  return (
    <>
      <SEO
        title={t('faq.pageTitle')}
        description={t('faq.pageDescription')}
        keywords={t('seo.faq.keywords')}
        type="website"
      />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-racing-black via-racing-darkGray to-gray-900 text-white py-16">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-display font-bold mb-4">
              {t('faq.title')}
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              {t('faq.subtitle')}
            </p>
          </motion.div>
        </div>
      </section>

      

      {/* Common Questions Section */}
      <section className="py-16 bg-gray-50">
        <div className="container-custom max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold text-racing-black mb-4">
              {t('faq.commonQuestions')}
            </h2>
            <p className="text-xl text-gray-600">
              {t('faq.commonQuestionsDesc')}
            </p>
          </motion.div>

          <div className="space-y-4">
            {commonQuestions.map((item, index) => (
              <motion.details
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                className="card p-6 cursor-pointer group"
              >
                <summary className="font-bold text-gray-900 list-none flex items-center justify-between">
                  <span className="flex items-center">
                    <svg className="w-5 h-5 text-racing-red mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    {t(item.questionKey)}
                  </span>
                  <svg className="w-5 h-5 text-gray-400 group-open:rotate-180 transition-transform flex-shrink-0 ml-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </summary>
                <div className="mt-4 text-gray-600 pl-8">
                  {t(item.answerKey)}
                </div>
              </motion.details>
            ))}
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-gradient-to-br from-racing-black via-racing-darkGray to-gray-900 text-white">
        <div className="container-custom text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
              {t('faq.stillHaveQuestions')}
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
              {t('faq.contactUsDesc')}
            </p>
            <a
              href="/contact"
              className="inline-block px-8 py-4 bg-racing-red hover:bg-racing-darkRed text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105"
            >
              {t('faq.contactButton')}
            </a>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default FAQ;
